<template>
  <section class="is-hidden-tablet">

    <!-- action wrap -->
    <div  :class="(filterScreen == 1 ? 'active' : '') + ' mobile-filter-actions-wrap default-mobile-actions'">
     <div class="mobile-filter-actions-manage">
       <div class="open-filter-modal-wrap">
         <a href="#" @click.prevent="changeScreen(3)" class="open-filter-modal"><i class="fas fa-angle-up"></i></a> 
       </div>
        <router-link class="button bg-secondary text-white" :to="{ name: 'HomePage', params: { business_slug: $route.params.business_slug }, query: $route.query}">BACK</router-link>
         <a class="button bg-secondary text-white" href="#" @click.prevent="viewCart()">CART</a>
     </div>
    </div>
    <!-- action wrap ends -->

    <!-- action with menu wrap -->
    <div :class="(filterScreen == 2 ? 'active' : '') + ' mobile-action-withmenu-options-wrap'">
      <div class="mobile-action-menus">
        <!-- <a href="#" class="button is-fullwidth mb-3" @click.prevent="moveToAccount()">ACCOUNT</a>
        <a href="#" class="button is-fullwidth mb-3" @click.prevent="moveToUserFavorites()">FAVORITES</a> -->
        <!-- <button class="button is-fullwidth mb-3" @click.prevent="changeScreen(3)">FILTER</button>
        <button class="button is-fullwidth mb-3" @click.prevent="changeScreen(4)">SORT</button> -->
      </div>
      <div class="mobile-filter-actions-wrap">
        <div class="mobile-filter-actions-manage">
          <div class="open-filter-modal-wrap">
            <a href="#" @click.prevent="changeScreen(1)" class="open-filter-modal"><i class="fas fa-angle-down"></i></a> 
          </div>
          <router-link class="button bg-secondary text-white" :to="{ name: 'HomePage', params: { business_slug: $route.params.business_slug }, query: $route.query}">BACK</router-link>
          <a class="button bg-secondary text-white" href="#" @click.prevent="viewCart()">CART</a>
        </div>
      </div>
    </div>
    <!-- action with menu wrap ends -->

    <!-- action with filter wrap -->
    <div :class="(filterScreen == 3 ? 'active' : '') + ' mobile-action-with-filter-wrap'">
      <div class="mobile-filters-wrap">
       <filter-main-content :sizes="sizes" :activesubcategory="activesubcategory" :showheading="false"/>
      </div>
      <div class="mobile-filter-actions-wrap">
      <div class="mobile-filter-actions-manage">
          <div class="open-filter-modal-wrap">
            <a href="#" @click.prevent="changeScreen(1)" class="open-filter-modal"><i class="fas fa-angle-down"></i></a> 
          </div>
          <button class="button bg-secondary text-white" @click.prevent="clearFilter()">CLEAR</button>
          <button class="button bg-secondary text-white" @click.prevent="filterScreen = 1">SHOW ITEMS</button>
        </div>
      </div>
    </div>
    <!-- action with filter wrap ends -->

     <!-- action with filter wrap -->
    <div :class="(filterScreen == 4 ? 'active' : '') + ' mobile-action-with-filter-wrap mobile-flyout-sort'">
      <div class="mobile-filters-wrap">
        <div class="flyout-sort-list">
          <ul>
             <li :class="vg_filters.sort == key ? 'active' : ''" v-for="(val,key) in sortKeyValues" v-bind:key="key" :value="key"><a href="#"  @click="changeSort(key)">{{ val }}</a></li>
          </ul>
        </div>
      </div>
      <div class="mobile-filter-actions-wrap">
      <div class="mobile-filter-actions-manage">
          <div class="open-filter-modal-wrap">
            <a href="#" @click.prevent="changeScreen(1)" class="open-filter-modal"><i class="fas fa-angle-down"></i></a> 
          </div>
          <button class="button is-primary" @click.prevent="changeScreen(2)">BACK</button>
        </div>
      </div>
    </div>
    <!-- action with filter wrap ends -->

  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import FilterMainContent from "@/Components/Pages/PageComponents/StoreProfile/FilterMainContent";
import Env from '@/env';

export default {
  components:{
    FilterMainContent
  },
  props: ['activesubcategory', 'sizes'],
  data() {
    return {
      // sortKeyValues: {
      //   default: "Default",
      //   low: "Price: Low - High",
      //   high: "Price: High – Low",
      //   thc_low: "THC: Low - High",
      //   thc_high: "THC: High - Low",
      //   cbd_low: "CBD: Low - High",
      //   cbd_high: "CBD: High - Low",
      //   alphabetical: "A-Z",
      // },
      filterScreen: 1,
      totalFilteredProductCount: 0,
    }
  },

  computed: {
    ...mapGetters({
      vg_filters: "searchproduct/searchFilter",   
    }),
    sortKeyValues() {
      return Env.productSortKeyValues;
    },
  },

  mounted() {
    // bus.$on('filtered-product-count', (payload) => {
    //   this.totalFilteredProductCount = payload;
    // });

    bus.$on('filter-selected-category-product-count', (payload) => {
      this.totalFilteredProductCount = payload;
    });

    bus.$on('change-flyout-screen', (payload) => {
      this.changeScreen(payload);
    });

  },

  beforeDestroy() {
    bus.$off('filtered-product-count');
    bus.$off('filter-selected-category-product-count');
    bus.$off('change-flyout-screen');
  },

  methods: {
    /**
     * Change Sort
     */
    changeSort(val) {
      this.vg_filters.sort = val;
      // now emit filter now
      bus.$emit('filter-now', true)
      this.filterScreen = 1;

    },

    /*
    * Change screen layout
    */
    changeScreen(val) {
      this.filterScreen = val;
    },

    /**
     * Clear filter
     */
    clearFilter() {
      // Emit event to clear filter
      bus.$emit('clear-filter', true);
    },

    /**
     * Move to favorite page with checking
     */
    moveToUserFavorites() {
      if(this.$store.getters.getLoggedInUserToken){
        this.$router.push({
          name: 'UserFavouriteProducts',
          params: { 
            business_slug: this.$route.params.business_slug, 
            store_slug: this.$route.params.store_slug }
        })
      } else {
        this.snackbar({
          message:  'Please login to proceed.',
          type: 'error',
        });
      }
    },

    /**
     * Move to myaccount page with checking
     */
    moveToAccount() {
      if(this.$store.getters.getLoggedInUserToken){
        this.$router.push({
          name: 'UserEditAccount',
          params: { 
            business_slug: this.$route.params.business_slug
          }
        });
      } else {
        this.snackbar({
          message:  'Please login to proceed.',
          type: 'error',
        });
      }
    },

    /**
     * Open cart side modal
     */
    viewCart() {
      bus.$emit('open-sidebar-cart', true);
    },

    ...mapActions({
      snackbar: "snackbar/setSnackbar",
    })

  },
}
</script>
